import * as React from "react";
const Server = props => <symbol viewBox="0 0 24 24" {...props}>
    <g>
      <path d="M17.75 8a.75.75 0 00-.75-.75h-6a.75.75 0 100 1.5h6a.75.75 0 00.75-.75zM6.47 7.47a.75.75 0 101.06 0 .774.774 0 00-1.06 0z" />
      <path d="M19.54 12A4.74 4.74 0 0017 3.25H7A4.74 4.74 0 004.46 12 4.74 4.74 0 007 20.75h10A4.741 4.741 0 0019.54 12zM3.75 8A3.254 3.254 0 017 4.75h10a3.25 3.25 0 110 6.5H7A3.254 3.254 0 013.75 8zM17 19.25H7a3.25 3.25 0 110-6.5h10a3.25 3.25 0 110 6.5z" />
      <path d="M17 15.25h-6a.75.75 0 100 1.5h6a.75.75 0 100-1.5zm-9.856.015a.76.76 0 00-.674.205.76.76 0 00-.22.53.75.75 0 101.44-.29.76.76 0 00-.546-.445z" />
    </g>
  </symbol>;
export default Server;